<div class="col-lg-12">
  <div class="content-container">
    <fieldset>
      <h2>User does not exist</h2>
      <h3>The logged in User is not authorised to access CAART</h3>
    </fieldset>
  </div>
</div>
<div>
  
  <a (click)="logout()"><button class="btn btn-lg btn-primary loginbuttonStyle">Logout</button></a>

</div>